import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('bringozDate', bringozDate);

function bringozDate(splitService, moment) {
  return function bringozDateFilter(object, ref, displayTime, timeZoneId) {
    if (object && object[ref]) {
      let format = splitService.getDateAndTimeConfig().date;
      if (displayTime) {
        format += ', ' + splitService.getDateAndTimeConfig().time;
      }
      if (timeZoneId) {
        return moment(object[ref]).tz(timeZoneId).format(format);
      } else {
        return moment(object[ref]).format(format);
      }
    } else {
      return '---';
    }
  }
}
